import { useQuery } from '@tanstack/react-query';
import { getModerationQueue } from '@/services/api/adminListingsApi';

export const useModerationQueue = (
  statusFilter: 'all' | 'pending' | 'approved' | 'rejected' | 'unassigned',
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ['admin-listings-queue', statusFilter],
    queryFn: async () => {
      const response = await getModerationQueue(statusFilter);
      return response.items;
    },
    enabled,
  });
};